import React, { useState, useEffect, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faChevronLeft, faUsers } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import { AppContext } from "../context/appContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import * as func from "../../api/apiHelper";
import * as urls from "../../api/urlHelper";
import { MST_MODEL_NAMES } from "../../config/enum";
import AsyncSelect from "react-select/async";
import { createLoadOptions } from "../../utilities";

const inputCls =
  "w-full px-3 mt-1 text-sm py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500";

const EditMatchSeeker = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [updateMatchSeekerData, setUpdateMatchSeekerData] = useState({
    fullName: "",
    emailId: "",
    religion: {},
    caste: null,
    subCaste: "",
    userId: {},
    matchMakerPreferences: {
      religion: "",
      caste: "",
      residentLocation: "",
    },
  });
  const { matchseekerMasterData } = useContext(AppContext);

  useEffect(() => {
    const fetchMatchSeekerDetails = async () => {
      const response = await func.get(urls.GET_MATCHSEEKER_BY_ID_URL + id);
      if (response.status === 200) {
        const { preferences, ...rest } = response.data?.data;
        setUpdateMatchSeekerData({
          ...rest,
          matchMakerPreferences: {
            ...preferences,
            residentLocation: preferences?.locationPreferences,
          },
        });
      } else {
        toast.warn(response);
        navigate("/user-management/match-seekers/list");
      }
    };

    if (id) fetchMatchSeekerDetails();
  }, [id]);

  const handleUpdateMatchSeeker = async () => {
    const { fullName, emailId, caste, subCaste, religion, userId } = updateMatchSeekerData;

    if (!fullName) { toast.warn("All user fields must be filled"); return; }
    if (fullName.trim().length < 3) { toast.warn("Full name must be at least 3 characters long"); return; }
    if (userId._phoneNumber.trim() === "" || userId._phoneNumber.length < 10) {
      toast.warn("Enter Valid Mobile Number"); return;
    }
    if (userId._accountStatus.trim() === "") { toast.warn("Select Valid Account status"); return; }
    if (emailId && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailId.trim())) {
      toast.warn("Please provide a valid email address"); return;
    }
    if (emailId && emailId.trim().length > 40) { toast.warn("Only 40 Characters allowed in the email id"); return; }

    const apidata = {
      ...updateMatchSeekerData,
      emailId: emailId ? emailId.toLowerCase() : null,
      caste: caste ? caste.value : null,
      subCaste: subCaste || "",
      religion: religion ? religion.value : null,
      userId: userId?._id,
      newMobileNo: userId?._phoneNumber,
      newAccountStatus: userId?._accountStatus,
      matchMakerPreferences: {
        religion: updateMatchSeekerData.matchMakerPreferences?.religion
          ? updateMatchSeekerData.matchMakerPreferences?.religion?.value
          : null,
        caste: updateMatchSeekerData.matchMakerPreferences?.caste
          ? updateMatchSeekerData.matchMakerPreferences?.caste?.value
          : null,
        residentLocation: updateMatchSeekerData.matchMakerPreferences?.residentLocation
          ? updateMatchSeekerData.matchMakerPreferences?.residentLocation?.value
          : null,
      },
    };

    const response = await func.put(
      urls.EDIT_MATCHSEEKER_URL + updateMatchSeekerData._id,
      apidata
    );

    if (response.status === 200 || response.status === 201) {
      toast.success("Match Seeker Updated Successfully");
      navigate("/user-management/match-seekers/list");
    } else {
      toast.warn(response);
    }
  };

  return (
    <div className="min-h-screen bg-[linear-gradient(to_left,_#19224B,_#E2B865)] p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <button
            onClick={() => navigate(-1)}
            className="w-8 h-8 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition text-white"
          >
            <FontAwesomeIcon icon={faChevronLeft} className="text-sm" />
          </button>
          <div className="flex items-center gap-2">
            <FontAwesomeIcon icon={faUsers} className="text-white text-lg" />
            <h1 className="text-lg font-semibold text-white">Edit Match Seeker</h1>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-6 space-y-6">
          {/* Personal Details */}
          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
              Personal Details
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={updateMatchSeekerData.fullName}
                  onChange={(e) => setUpdateMatchSeekerData({ ...updateMatchSeekerData, fullName: e.target.value })}
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 30))}
                  className={inputCls}
                  placeholder="Full Name"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Email</label>
                <input
                  type="email"
                  value={updateMatchSeekerData.emailId}
                  onChange={(e) => setUpdateMatchSeekerData({ ...updateMatchSeekerData, emailId: e.target.value })}
                  onInput={(e) => (e.target.value = e.target.value.slice(0, 40))}
                  className={inputCls}
                  placeholder="Email"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Religion</label>
                <div className="mt-1">
                  <AsyncSelect
                    placeholder="Select Religion"
                    isClearable
                    defaultOptions={matchseekerMasterData["mst-religion"]?.slice(0, 5)?.map((r) => ({
                      value: r._id,
                      label: r.religion,
                    }))}
                    cacheOptions
                    loadOptions={createLoadOptions(MST_MODEL_NAMES[9])}
                    value={updateMatchSeekerData.religion}
                    onChange={(e) => setUpdateMatchSeekerData({ ...updateMatchSeekerData, religion: e, caste: "" })}
                  />
                </div>
              </div>

              {updateMatchSeekerData.religion ? (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Caste</label>
                    <div className="mt-1">
                      <AsyncSelect
                        placeholder="Select Caste"
                        name="caste"
                        isDisabled={!updateMatchSeekerData.religion?.value}
                        isClearable
                        cacheOptions
                        loadOptions={createLoadOptions(MST_MODEL_NAMES[10], 50, updateMatchSeekerData.religion?._id)}
                        value={updateMatchSeekerData.caste}
                        onChange={(e) => setUpdateMatchSeekerData({ ...updateMatchSeekerData, caste: e })}
                        defaultOptions={matchseekerMasterData["mst-caste"]
                          ?.slice(0, 10)
                          ?.filter((each) => each.religionId === updateMatchSeekerData?.religion?.value)
                          ?.map((r) => ({ value: r._id, label: r.caste }))}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Sub Caste</label>
                    <input
                      value={updateMatchSeekerData.subCaste}
                      type="text"
                      onChange={(e) => setUpdateMatchSeekerData({ ...updateMatchSeekerData, subCaste: e.target.value })}
                      onInput={(e) => {
                        let value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                        if (value.trim() === "") value = "";
                        e.target.value = value;
                      }}
                      placeholder="Enter SubCaste Name"
                      className={inputCls}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Caste</label>
                    <select value={updateMatchSeekerData.caste?._id} disabled className={`${inputCls} bg-gray-50`}>
                      <option value="">Select Caste</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Sub Caste</label>
                    <input value={updateMatchSeekerData.subCaste} type="text" disabled className={`${inputCls} bg-gray-50`} />
                  </div>
                </>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700">Account Status</label>
                <select
                  value={updateMatchSeekerData.userId?._accountStatus}
                  onChange={(e) =>
                    setUpdateMatchSeekerData({
                      ...updateMatchSeekerData,
                      userId: { ...updateMatchSeekerData.userId, _accountStatus: e.target.value },
                    })
                  }
                  className={inputCls}
                >
                  <option value="">Select Status</option>
                  <option value="BLOCKED">Blocked</option>
                  <option value="INACTIVE">In Active</option>
                  <option value="ACTIVE">Active</option>
                </select>
              </div>
            </div>
          </div>

          {/* Preferences */}
          <div>
            <h3 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">
              Preferences
            </h3>
            <p className="text-xs text-gray-500 mb-3">Select preferences to scout profiles</p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div>
                <label className="block text-sm font-medium text-gray-700">Religion</label>
                <div className="mt-1">
                  <AsyncSelect
                    placeholder="Select Religion"
                    isClearable
                    defaultOptions={matchseekerMasterData["mst-religion"]?.slice(0, 5)?.map((r) => ({
                      value: r._id,
                      label: r.religion,
                    }))}
                    cacheOptions
                    loadOptions={createLoadOptions(MST_MODEL_NAMES[9])}
                    value={updateMatchSeekerData.matchMakerPreferences.religion}
                    onChange={(e) =>
                      setUpdateMatchSeekerData({
                        ...updateMatchSeekerData,
                        matchMakerPreferences: { ...updateMatchSeekerData.matchMakerPreferences, religion: e, caste: null },
                      })
                    }
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Caste</label>
                <div className="mt-1">
                  <AsyncSelect
                    placeholder="Select Caste"
                    isDisabled={!updateMatchSeekerData.matchMakerPreferences.religion?.value}
                    isClearable
                    cacheOptions
                    loadOptions={createLoadOptions(MST_MODEL_NAMES[10], 50, updateMatchSeekerData.matchMakerPreferences.religion?.value)}
                    value={updateMatchSeekerData.matchMakerPreferences.caste}
                    onChange={(e) =>
                      setUpdateMatchSeekerData({
                        ...updateMatchSeekerData,
                        matchMakerPreferences: { ...updateMatchSeekerData.matchMakerPreferences, caste: e },
                      })
                    }
                    defaultOptions={matchseekerMasterData["mst-caste"]
                      ?.slice(0, 10)
                      ?.filter((each) => each.religionId === updateMatchSeekerData.matchMakerPreferences.religion?.value)
                      ?.map((r) => ({ value: r._id, label: r.caste }))}
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700">Resident Location</label>
                <div className="mt-1">
                  <AsyncSelect
                    placeholder="Select Location"
                    isClearable
                    cacheOptions
                    loadOptions={createLoadOptions(MST_MODEL_NAMES[19])}
                    defaultOptions={matchseekerMasterData["mst-location"]?.slice(0, 5)?.map((r) => ({
                      value: r._id,
                      label: r.city?.split(",")[0],
                    }))}
                    value={updateMatchSeekerData.matchMakerPreferences.residentLocation}
                    onChange={(e) =>
                      setUpdateMatchSeekerData({
                        ...updateMatchSeekerData,
                        matchMakerPreferences: { ...updateMatchSeekerData.matchMakerPreferences, residentLocation: e },
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <p className="text-xs text-gray-500">
            <span className="text-red-500">*</span> Represents required fields
          </p>

          <div className="flex justify-end">
            <button
              onClick={handleUpdateMatchSeeker}
              className="flex items-center gap-2 px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md text-sm font-medium transition"
            >
              <FontAwesomeIcon icon={faPaperPlane} />
              Save Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMatchSeeker;
